(ns kyber.subscriptions.authentication)

(defn is-authenticated?
  [db _]
  (some? (some-> db :session :cognito-session .getIdToken .getJwtToken)))

(defn user-attributes
  ([db] (user-attributes db nil))
  ([db _]
   (get-in db [:session :user])))

(defn has-permissions?
  [db _]
  (some? (-> db (user-attributes) :permissions)))

(defn session-token
  ([db] (session-token db nil))
  ([db _]
   (some-> db :session :cognito-session .getIdToken .getJwtToken)))

(defn has-access?
  [db [_ view-key {:keys [curriculum-uuid]}]]
  (let [permission-map
        (cond-> (-> db (user-attributes) :permissions)
          (some? curriculum-uuid)
          (get-in [:curriculum/permissions
                   (keyword curriculum-uuid)]))

        curriculua-wildcard-permissions
        (-> db (user-attributes) :permissions :curriculum/permissions :*)]
    (or (-> permission-map view-key boolean)
        (-> curriculua-wildcard-permissions view-key boolean))))

(defn passwordless-sign-in-email
  [db _]
  (get db :passwordless-email-sent-to))

;; 2023-07-10 Justin - This subscription is used for disabling passwordless login under certain conditions
;; Check [[10716]] for more information
(defn activity-idp-integrations
  [db [_ {activity-uuid :activity/uuid}]]
  (get-in db [:public :activity activity-uuid :activity/idp-integrations]))
